var map = {
	"./CS4-1.png": "89ba",
	"./CS4-2.png": "6a4f",
	"./CS4-3.png": "4b94",
	"./CS4-4.png": "0cd6",
	"./abi-gray.png": "2f8b",
	"./abi-green.png": "1605",
	"./bp-red.png": "0770",
	"./bp-yellow.png": "f9e8",
	"./ecg.png": "7b8a",
	"./mtablet.png": "ab9e",
	"./spiro.png": "e4d8",
	"./spo2.png": "9184",
	"./tbp.png": "876d",
	"./thermo.png": "9d9b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ef4";